import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { CareActions } from './care.actions';
import {
  selectCareRecipients,
  selectSelectedRecipientId,
  selectSelectedRecipient,
  selectCareLoading,
  selectCareError
} from './care.selectors';

/**
 * Facade service for care state management
 * Provides clean API for components to interact with care NgRx store
 */
@Injectable({
  providedIn: 'root'
})
export class CareFacade {
  private readonly store = inject(Store);

  // Observables
  readonly careRecipients$ = this.store.select(selectCareRecipients);
  readonly selectedRecipientId$ = this.store.select(selectSelectedRecipientId);
  readonly selectedRecipient$ = this.store.select(selectSelectedRecipient);
  readonly loading$ = this.store.select(selectCareLoading);
  readonly error$ = this.store.select(selectCareError);

  // Actions
  loadCareRecipients(): void {
    this.store.dispatch(CareActions.loadCareRecipients());
  }

  revokeLink(linkId: string): void {
    this.store.dispatch(CareActions.revokeLink({ linkId }));
  }

  selectRecipient(userId: string): void {
    this.store.dispatch(CareActions.selectRecipient({ userId }));
  }

  clearState(): void {
    this.store.dispatch(CareActions.clearCareState());
  }
}
